import gql from 'graphql-tag';

export default gql`
query GetPendingUsers(
        $lang: String!
        ) {
    getPendingUsers(
        lang: $lang
    ) {
      items {
        __typename
        uuid
        image
        langs
        name
        desc
        rating
        reviews
      }
    }
}
`;
